export const PLAYER_NAMES_SESSION_STORAGE_KEY = 'session-player-names';
export const PREVIOUS_PLAYER_NAMES_STORAGE_KEY = 'previous-player-names';
